import { render } from "./MergedKnowledgeList.vue?vue&type=template&id=7ea04961&scoped=true"
import script from "./MergedKnowledgeList.vue?vue&type=script&lang=js"
export * from "./MergedKnowledgeList.vue?vue&type=script&lang=js"

import "./MergedKnowledgeList.vue?vue&type=style&index=0&id=7ea04961&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ea04961"]])

export default __exports__